<template>
    <div id="bank_receipt_adjustment" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="ReceiptInvoiceHeader">Maintain Payment Invoice</span>
                    <div class="web-action-btn btn-groups text-right">
                        <button type="submit" class="btn btn-secondary" v-on:click.prevent="BackReceiptList" >
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content map-receipt-invoice">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form invoice-mapper" id="ReceiptInvoiceMapperForm">
                                <div class="form-row">
                                    <div class="col-md-7 form-group">
                                        <div class="form-row">
                                            <!-- <div class="col form-group">
                                                <label class="control-label" for="receipt">Receipt/Payment Number:</label>
                                                <v-select v-model="receiptPayment" name="receipt"
                                                        label="text" :filterable="false" :options="receiptPaymentArr"
                                                        @search="onSearchReceiptPayment"
                                                        placeholder="Select Receipt" class="custom-ci-auto-search">
                                                    <template slot="no-options">
                                                        Search Receipt/Payment...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                            </div> -->
                                        </div>
                                        <template>
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label">Search Customer/Invoice#</label>
                                                    <div class="border-1">
                                                        <div class="form-row">
                                                            <div class="col-md-5">
                                                                <label class="control-label" for="customer_id">Customer:</label>
                                                                <v-select v-model="customer_id" name="customer_id" id="customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" placeholder="Select Customer" class='custom-ci-auto-search'>
                                                                    <template slot="no-options">
                                                                        Search Customer...
                                                                    </template>
                                                                    <template slot="option" slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                </template>
                                                                </v-select>
                                                                <div class="field-error">{{ customer_error_msg }}</div>
                                                            </div>
                                                            <div class="col-md-5">
                                                                <label class="control-label" for="invoice_id">Invoice Number:</label>
                                                                <v-select v-model="invoice_id" name="invoice_id" multiple id="invoice_id" label="text" :filterable="false" :options="invoiceArr" @search="onSearchInvoice" placeholder="Select Invoice" class='custom-ci-auto-search invoice-multiple'>
                                                                    <template slot="no-options">
                                                                        Search Invoice...
                                                                    </template>
                                                                    <template slot="option" multiple slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" multiple slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                </v-select>
                                                                <div class="field-error">{{ invoice_error_msg }}</div>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <button type="submit" v-on:click.prevent="getInvoices()" class="btn btn-primary mt-4">
                                                                    <i class="fp-add"></i> Add
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="misc-cash mt-5" style="font-size:0.9rem;">
                                                <a href="javascript:void(0)" v-on:click.prevent="creditDeposit()" class="color-blue underline">
                                                    Security Deposit
                                                </a>

                                                <span class="clearfix display-block mt-2"></span>
                                                <a href="javascript:void(0)" v-on:click.prevent="onAccountApp()" class="color-blue underline">
                                                    On Account Fund
                                                </a>
                                                <span class="clearfix display-block mt-2"></span>
                                                <a href="javascript:void(0)" v-on:click.prevent="cashFlow()" class="color-blue underline">
                                                    Direct GL Entry
                                                </a>

                                                <template v-if="creditrows && creditrows.length > 0 && onSecurityDeposit">
                                                  <span class="clearfix display-block mt-2"></span>
                                                  <div class="custom-checkbox">
                                                      <label class="checkbox-custom">With Asset
                                                        <input type="checkbox" v-model="isUnit" id="isUnit"
                                                        name="isUnit" v-on:click="isUnitSelect($event)">
                                                        <span class="checkmark"></span>
                                                      </label>
                                                  </div>
                                                </template>


                                            </div> -->
                                        </template>
                                    </div>
                                    <div class="col-md-5">
                                        <template v-if="payment_number != ''">
                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <tr class="table-active">
                                                    <td>Payment Number: </td>
                                                    <td>Payment Date: </td>
                                                </tr>
                                                <tr>
                                                    <td>{{payment_number}}</td>
                                                    <td>{{payment_date}}</td>
                                                </tr>
                                                <tr class="table-active">
                                                    <td>Bank Code:</td>
                                                    <td>Payment Type:</td>
                                                </tr>
                                                <tr>
                                                    <td>{{bank_code}}</td>
                                                    <td>{{payment_type}}</td>
                                                </tr>
                                            </table>
                                            <table aria-describedby="table" class="table table-sm table-bordered" style="font-size:14px;">
                                                <tr>
                                                    <td class="bg-gray require valign-middle"> PMT Amount: </td>
                                                    <td class="text-right" > ${{payment_amount.toFixed(2)}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="bg-gray"> Amt Applied: </td>
                                                    <td class="text-right"> ${{amount_applied.toFixed(2)}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="bg-gray"> Difference: </td>
                                                    <td class="text-right font-semibold"> ${{difference.toFixed(2)}} </td>
                                                </tr>
                                            </table>
                                        </template>
                                    </div>
                                </div>
                                <template>
                                    <div class="purchase-order-create-main table-responsive-sm" v-show="rows && rows.length > 0 && !specificInvoice">
                                        <!-- <div v-if="idArr && idArr.length > 0" class="selection-info-row">
                                            <a href="javascript:void(0)" v-on:click.prevent="cancelReceiptPayment()" class="color-blue underline">Cancel</a>
                                        </div> -->
                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                            <thead>
                                                <tr class="table-primary">
                                                    <!-- <th scope="col" style="width:10px;"></th> -->
                                                    <th scope="col" style="width:200px;">Customer</th>
                                                    <th scope="col">Invoice Number</th>
                                                    <th scope="col">Original Amount</th>
                                                    <th scope="col">Open Amount</th>
                                                    <th scope="col" style="width:20px;">Status</th>
                                                    <th scope="col" style="width:20px;">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, index) in rows" :key="index">
                                                    <!-- <td>
                                                        <input type="checkbox" id="cancelCheckbox" @input="clickRows($event,row.mapper_id)"/>
                                                    </td> -->
                                                    <td>
                                                        {{row.customer_number}}
                                                    </td>
                                                    <td>
                                                        {{row.invoice_number}}
                                                    </td>
                                                    <td v-if="row.invoice_amount">
                                                        ${{row.invoice_amount.toFixed(2)}}
                                                    </td>
                                                    <td>
                                                        ${{row.current_open_inv_amount.toFixed(2)}}
                                                    </td>
                                                    <td>
                                                        <span v-if="row.mapper_id > 0">
                                                            Applied
                                                        </span>
                                                        <span v-else>
                                                            Un applied
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <template v-if="rows.length > 0">
                                                            <!-- <a href="javascript:void(0)" v-if="row.current_open_inv_amount > 0" v-on:click.prevent="grossInvoice(row.invoice_id,row.current_open_inv_amount)" class="color-blue underline">
                                                                Gross
                                                            </a> -->
                                                            <a  href="javascript:void(0)" v-if="row.current_open_inv_amount != 0" v-on:click.prevent="spInvoice(row.invoice_id,row.current_open_inv_amount)" class="color-blue underline">
                                                                Specific
                                                            </a>
                                                            <span class="close-row" v-if="row.current_open_inv_amount == 0"> - </span>
                                                        </template>
                                                        <template v-else>
                                                            <span class="close-row"> - </span>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <template v-if="specificInvoice">
                                        <div class="form-row">
                                            <div class="col-md-7">
                                                <div class="specific-calc">
                                                    <div class="font-1 font-bold">Specific Amount Calculation</div>
                                                    <div class="specific-calc-wrapper">
                                                    <input type="hidden" class="form-control" v-model="spc_invoice_id"/>
                                                    <div class="form-row">
                                                        <div class="col-sm-6 form-group mt-4">
                                                            <label class="control-label" for="name">Open Amount: &nbsp;&nbsp;${{open_amount.toFixed(2)}}</label>
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="col-sm-6 form-group">
                                                            <label class="control-label" for="name">Application Amount:</label>
                                                            <input type="text" class="form-control" v-model="application_amount" id="application_amount" placeholder="Enter Application Amount" name="application_amount" @keypress="isNumberKey($event)">
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="col-sm-6 form-group">
                                                            <label class="control-label" for="bdwo">WO-Amount:</label>
                                                            <input type="text" class="form-control" v-model="bdwo" id="bdwo" placeholder="Enter Write off Amount" name="bdwo" @keypress="isNumberKey($event)">
                                                        </div>
                                                        <div class="col-sm-6 form-group">
                                                            <label class="control-label" for="gl_account">Write Off Account:</label>
                                                            <v-select v-model="bd_gl_account_id" name="bd_gl_account_id" id="bd_gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                                <template slot="no-options">
                                                                    Search GL Account...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                            <div class="field-error">{{gl_account_error_msg}}</div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                </template>
                                <div class="field-error">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups" v-if="specificInvoice">
                                    <button type="submit" id="createReceiptBtn" class="btn btn-primary" v-on:click.prevent="mapSpecificInvoiceReceipt" >
                                    <i class="fp-reload"> </i>  Adjust
                                    </button>
                                    <!-- <button type="submit" id="createReceiptBtn" v-else class="btn btn-primary" v-on:click.prevent="mapSpecificInvoiceReceipt">
                                    <i class="fp-save"> </i>  Save
                                    </button> -->
                                    <button type="submit" id="cancelReceiptBtn" class="btn btn-tertiary" v-on:click="specificInvoice = false;">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';

import moment from 'moment'


export default {
  name: "BankReceiptAdjustment",
  
  metaInfo() {
      return {title: "Adjust Payment | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    isUnit: true,
    permissions: [],
    cantAccessPage: "",
    loading:false,
    payment_number:'',
    payment_date:'',
    bank_code:'',
    bankArr:[],
    bank_currency_code:'USD',
    payment_currency_code:'USD',
    rows:[],
    bank_reference:'',
    bank_error_msg:'',
    deposit_date_error_msg:'',
    receipt_date_error_msg:'',
    receipt_amount_error_msg:'',
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    difference:0.00,
    amount_applied:0.00,
    payment_amount:0.00,
    dist_company:'001',
    isRelease:false,
    receiptPaymentArr:[],
    receiptPayment:'',
    invoiceArr:[],
    invoice_id:'',
    invoice_error_msg:'',
    payment_type:'',
    customer_id:0,
    customerArr:[],
    customer_error_msg:'',
    specificInvoice:false,
    gl_account_error_msg:'',
    accountsArr:[],
    open_amount:0.00,
    spc_invoice_id:0,
    current_open_amount:0,
    common_error_msg:"",
    glDisabled:false,
    custDisabled:false,
    adjustButton:true,
    adjustFlow:false,
    vehicleArr:[],
    bdwo:0,
    bd_gl_account_id:'',
    inCreate:false,
    application_amount:0
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_payment_receipt') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },

        // receiptPayment:function(val){
        //     var self = this;

        //     if (val != null){
        //         self.payment_number = val.payment_no;
        //         self.payment_date = val.payment_date;
        //         self.payment_type =  val.type;
        //         self.payment_amount = val.payment_amount;
        //         self.difference = val.difference;
        //         self.amount_applied = val.applied_amount;
        //         self.bank_code = val.bank_code;
        //         self.bd_gl_account_id = {text:val.gl_desc,value:val.gl_id};

        //     }
        // },
        
        customer_id:function(){
            var self = this;

            self.onSearchInvoice('');
        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            // var path = window.location.pathname;
            // var segments = path.split("/");
            // if (segments[2]) {
            //     self.getReceiptPayment(segments[2],'load');

            //     setTimeout(function(){

            //         // self.getMappedItems();

            //     },500);
            // }else{
            //     self.inCreate = true;
            // }
            self.getReceiptPayment('','only_gl');
        }, 100);

        // self.fetchBanks();
  },
  methods: {
      isUnitSelect(event) {
          var self = this;
          self.isUnit = event.target.checked;
      },
      onSearchReceiptPayment(search, loading) {
        var self = this;
        // alert(search.length);
        if (search.length > 0) {
            // loading(true);
            self.getReceiptPayment(search,'search');
        }

    },
    onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'accounts', '');
            }
        },
    onSearchCustomer(search, loading) {
        var self = this;

        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },
    onSearchVehicle(search, loading) {
        var self = this;

        if (search.length > 3) {

            loading(true);
            self.searchField(loading, search, 'vehicle', '');
        }
    },
    spInvoice:function(id,currentOpenInvAmt){
        // $('.purchase-order-create-main').hide();
        var self = this;

        self.spc_invoice_id = id;
        self.application_amount = 0;
        // self.application_amount = self.difference;
        // if (self.adjustFlow === true){

            self.open_amount = currentOpenInvAmt;
            self.bdwo = currentOpenInvAmt;

        // }else{

        //     self.open_amount = self.difference;
        //     self.bdwo = self.difference;

        // }
        self.current_open_amount = currentOpenInvAmt;
        self.specificInvoice = true;
    },

    onSearchInvoice(search) {
        var self = this;
        var customerId = 0;
        if (self.customer_id == 0 || !self.customer_id.value){
            if (search.length < 4) {
                return;
            }
        }else{
            customerId = self.customer_id.value;
        }
            // self.searchField(loading, search, 'invoice', '');
        $.ajax({
            url: process.env.ROOT_API + "/invoices/customer/search",
            type: "POST",
            headers: this.ajxHeaders,
            data: {customer_id:customerId,flag:'invoice',search:search},
            crossDomain: true,
            dataType: "json",
            success: function (data) {
                self.invoiceArr = [];
                if (data.status == "success") {
                    self.invoiceArr = data.content;
                }else{
                    self.invoiceArr = [];
                }

            },
            error: function (jqXHR, exception) {
                loading(false);
                self.generateStatusCodeMessage(jqXHR,true,'customer-invoice-search');
            }
        });
    },
    // grossInvoice: function(invoiceId,currentOpenInvAmt){
    //     var self = this;
    //     if (currentOpenInvAmt > self.payment_amount) {
    //         self.$swal('','Open Amount cannot be greater than PMT Amount.','info');
    //         return;
    //     }else{
    //         $.ajax({
    //             url: process.env.ROOT_API + "/map-invoice-receipt",
    //             type: "POST",
    //             headers: {
    //                 "Accept": "application/json",
    //                 "Authorization": "Bearer " + localStorage.getItem("tkn"),
    //                 "Access-Control-Allow-Headers":
    //                     "Origin, Content-Type, Authorization,X-Requested-With",
    //                 "Cache-Control": "no-cache"
    //             },
    //             data:{
    //                 invoice_id:invoiceId,
    //                 receipt_item_id:self.receiptPayment.value
    //             },
    //             dataType: "json",
    //             success: function (data) {
    //                 self.loading = false;
    //                 console.log(data);
    //                 if (data.status == "success") {
    //                     self.amount_applied += data.content.application_amount;

    //                     self.calculateAmount();
    //                     self.getInvoices();
    //                 }
    //             },
    //             error: function (jqXHR, exception) {
    //                 self.loading = false;
    //                 self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
    //             }
    //         });
    //     }

    // },
    mapSpecificInvoiceReceipt:function(){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        var error = false;
        self.common_error_msg = "";

        if (self.application_amount != 0 && self.application_amount != ''){
            if ((Number(self.application_amount) > self.current_open_amount) || (Number(self.application_amount) > self.open_amount)) {
                self.common_error_msg = "Amount cannot be greater than Open Amount.";
                error = true;
            }
        }else{
            if ((Number(self.bdwo) > self.current_open_amount) || (Number(self.bdwo) > self.open_amount)) {
                self.common_error_msg = "Write Off Amount cannot be greater than Open Amount.";
                error = true;
            }
        }
        var bdgl = '';
        if (self.bd_gl_account_id != null && self.bd_gl_account_id.value){
            bdgl = self.bd_gl_account_id.value;
        }

        if (!error) {

            var fields = $("#ReceiptInvoiceMapperForm").serializeArray();

            if (self.receiptPayment != '' && self.receiptPayment != null){
                fields.push({
                    name: "bank_rec_id",
                    value: self.receiptPayment
                });
            }else{
                fields.push({
                    name: "bank_rec_id",
                    value: ''
                });
            }

                fields.push({
                        name: "invoice_id",
                        value: self.spc_invoice_id
                    });

                fields.push({
                        name: "bd_gl_account_id",
                        value: bdgl
                    });

                fields.push({
                        name: "bdwo",
                        value: self.bdwo
                    });
                fields.push({
                    name: "application_amount",
                    value: self.application_amount
                });

            var noNeedSp = false;

            if (noNeedSp){
                return;
            }

            $.ajax({
                url: process.env.ROOT_API + "/bank-invoice-adjustment",
                type: "POST",
                headers: this.ajxHeaders,
                data:fields,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.status == "success") {
                        self.receiptPayment = data.content.bank_rec_id;
                        // self.amount_applied += data.content.application_amount;
                        if (self.specificInvoice){

                            self.bdwo = 0;
                            self.open_amount = 0.00;
                            self.bd_gl_account_id = '';
                            self.getInvoices();
                            $('.purchase-order-create-main').show();
                        }
                        self.specificInvoice = false;
                        self.getReceiptPayment(self.receiptPayment,'load');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    // self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
                }
            });

        }

    },

    
    BackReceiptList() {
        var self = this;
        self.$router.push("/bank-transfer/list");
    },
    
    getReceiptPayment: function(search,flag = 'load'){
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/receipt_payment",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                search:search,
                flag:flag
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {

                    if (flag == 'only_gl'){
                        if (data.content.gl_id != undefined && data.content.gl_id != null){
                            self.bd_gl_account_id = {text:data.content.gl_desc,value:data.content.gl_id};
                        }

                        return;
                    }
                    if (flag == 'load'){
                        var dta = data.content[0];
                        self.receiptPayment = dta.value;
                        self.payment_date = dta.payment_date;
                        self.payment_type =  dta.type;
                        self.payment_amount = dta.payment_amount;
                        self.difference = dta.difference;
                        self.amount_applied = dta.applied_amount;
                        self.bank_code = dta.bank_code;
                        if (dta.gl_id != undefined && dta.gl_id != null){
                            self.bd_gl_account_id = {text:dta.gl_desc,value:dta.gl_id};
                        }
                        self.payment_number = dta.payment_no;
                    }else{

                        self.receiptPaymentArr = data.content;

                    }
                    // if (data.bank && self.$route.params.id == undefined){
                    //     self.bank_code = data.bank;
                    // }
                } else{

                    self.receiptPaymentArr = [];
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fetch-receipt-number')
            }
        });
    },

    // loadReceiptItem() {
    //     console.log("load receipt")
    //     var path = window.location.pathname;
    //     var segments = path.split("/");
    //     var self = this;
    //     self.loading = true;
    //     $.ajax({
    //         url: process.env.ROOT_API + "/one-receipt-item/" + self.receiptPayment.value,
    //         type: "GET",
    //         headers: {
    //             Accept: "application/json",
    //             "Authorization": "Bearer " + localStorage.getItem("tkn"),
    //             "Access-Control-Allow-Headers":
    //                 "Origin, Content-Type, Authorization,X-Requested-With",
    //             "Cache-Control": "no-cache"
    //         },
    //         dataType: "json",
    //         success: function (data) {
    //             self.loading = false;
    //             if (data.status == "success") {
    //                 self.adjustButton = false;
    //                 self.payment_number = data.content.payment_number;
    //                 self.payment_date = data.content.payment_date;
    //                 self.bank_code = data.content.bank_code;
    //                 self.payment_currency_code = data.content.payment_currency_code;
    //                 self.payment_type =  data.content.type;
    //                 self.payment_amount = data.content.payment_amount;
    //                 self.difference = data.content.difference;
    //                 self.amount_applied = data.content.applied_amount;

    //                 if (segments[3] && data.content.invoices.invoice){
    //                     self.invoice_id = data.content.invoices.invoice;
    //                     self.getInvoices();

    //                 }

    //                 if ( data.content.invoices.cust){
    //                     self.customer_id = data.content.invoices.cust;

    //                 }

    //                 if ( data.content.invoices.customer){
    //                     var cust = data.content.invoices.customer;
    //                     self.accrows = [];
    //                      self.accrows.push({
    //                         mapper_id: cust.id,
    //                         acc_customer_id: {text:cust.customer,value:cust.customer_id},
    //                         customer_error_msg: "",
    //                         description: cust.description,
    //                         amount: cust.amount,
    //                         amount_error_msg:'',
    //                     });
    //                     self.custDisabled = true;
    //                     if (segments[3]){
    //                         self.onAccount = true;
    //                     }
    //                     var amount = 0;
    //                     // var accomodation_amount = 0;

    //                     // if (cust.amount){

    //                     //     amount = cust.amount;
    //                     // }

    //                     // self.amount_applied += amount;
    //                 }
                    

    //                 self.calculateAmount();
    //             }
    //         },
    //         error: function (jqXHR, exception) {
    //             self.loading = false;
    //             self.generateStatusCodeMessage(jqXHR,true,'one-vendor-invoice-item');
    //         }
    //     });
    // },
    getInvoices: function(){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        var invArr = [];
        var customer_id = 0;
        if (!segments[3]){
            self.cashrows = [];
            self.accrows = [];
        }
        if(self.invoice_id != '' && self.invoice_id.length > 0){
            for(var i = 0; i < self.invoice_id.length; i++){
                invArr.push(self.invoice_id[i].value);
            }
        }else{
            if ( self.customer_id != null && self.customer_id.value ){
                customer_id = self.customer_id.value;
            }
        }

        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/get-receipt-invoices",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                id:invArr,
                customer_id:customer_id
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                   self.rows = data.content;
                    var amount = 0;
                    var accomodation_amount = 0;
                    self.invoiceArr = [];

                    if (!segments[3]){

                        // self.loadReceiptItem();

                    }
                            $("input:checkbox").prop('checked',false);


                //    self.calculateAmount();
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-items');
            }
        });
    },
    
    calculateAmount: function(){
        var self = this;

        // var amount = 0;
        // if(self.cashrows && self.cashrows.length > 0){

        //     for(var i = 0; i < self.cashrows.length; i++){
        //         if (self.cashrows[i].amount){
        //             amount += parseFloat(self.cashrows[i].amount);
        //             alert('amount ='+amount);
        //         }
        //         if (self.cashrows[i].tax){
        //             amount += parseFloat(self.cashrows[i].tax);

        //             alert('tax='+amount);
        //         }
        //     }

        // }
        // self.amount_applied += amount;

        self.difference = self.payment_amount - self.amount_applied;
    },
    
    isNumberKey: function(evt) {

        var self = this;

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1) && charCode != 45) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/accounting/BankReceiptAdjustment.vue